<template>
  <div>
    <v-row align="center" justify="center" class="pb-4">
      <template v-for="(component, index) in availableComponents">
        <v-menu
          :key="index"
          max-height="50vh"
          :close-on-content-click="component.closeOnClick"
          :nudge-width="100"
          offset-y
          :return-value.sync="buttonState[index]"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click="updateButtonState(index)"
              :input-value="buttonState[index]"
              active-class="white"
              :text="buttonState[index] == false ? true : false"
              small
              :disabled="!component.dataLoadedStatus"
            >
              {{ component.name }}
              <v-icon small right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <component :is="component.item"></component>
        </v-menu>
      </template>
    </v-row>
  </div>
</template>

<script>
import FilterStatesProvinces from '@/components/filter-states-provinces';
import FilterAssetType from '@/components/filter-asset-type';
import FilterStatus from '@/components/filter-status';
import { mapGetters } from 'vuex';

export default {
  components: {
    FilterStatesProvinces,
    FilterAssetType,
    FilterStatus
  },
  data() {
    return {
      buttonState: [false, false, false]
    };
  },
  computed: {
    ...mapGetters({
      locationsLoaded: 'filterData/locationsLoaded',
      assetTypesLoaded: 'filterData/assetTypesLoaded',
      statusValuesLoaded: 'filterData/statusValuesLoaded'
    }),
    availableComponents: function () {
      return [
        {
          item: 'FilterStatesProvinces',
          name: 'Locations',
          closeOnClick: true,
          dataLoadedStatus: this.locationsLoaded
        },
        {
          item: 'FilterAssetType',
          name: 'Asset Type',
          closeOnClick: false,
          dataLoadedStatus: this.assetTypesLoaded
        },
        {
          item: 'FilterStatus',
          name: 'Status',
          closeOnClick: false,
          dataLoadedStatus: this.statusValuesLoaded
        }
      ];
    }
  },
  methods: {
    updateButtonState(i) {
      this.buttonState[i] = !this.buttonState[i];
    }
  }
};
</script>
